var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 8,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "chevron-left_svg__a",
    d: "m2.4 7 5.3-5.3A1 1 0 0 0 6.3.3l-6 6a1 1 0 0 0 0 1.4l6 6a1 1 0 1 0 1.4-1.4L2.4 7z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chevron-left_svg__a"
  })));
};
export { SvgChevronLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggZD0iTTIuNCA3bDUuMy01LjNBMSAxIDAgMDA2LjMuM2wtNiA2YTEgMSAwIDAwMCAxLjRsNiA2YTEgMSAwIDEwMS40LTEuNEwyLjQgN3oiIGlkPSJjaGV2cm9uIi8+PC9kZWZzPjx1c2UgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjY2hldnJvbiIvPjwvc3ZnPg==";